<template>
  <div id='modelModificationPanel'><div id='modelModBtnPanel'>
  <el-button @click="moveModel" type="primary" circle icon="el-icon-rank"></el-button>
  <el-button @click="scaleModel" type="success" circle icon="el-icon-d-caret" ></el-button>
  <el-button @click="rotateModel" type="info" circle icon="el-icon-refresh"></el-button>
  <el-button @click="deleteModel" type="danger" circle icon="el-icon-delete"></el-button>
  <el-button @click="close" type="info" circle icon="el-icon-close"></el-button>
</div>
  <div id='modelSlider'><el-slider @input='sliderChange' style='position:absolute; left:0px; top:0px;width:150px;' ref ='slider' :min="min" :max="max" :step="sliderstep"
      v-model="sliderVal"
      >
    </el-slider>
    <el-button style="position:absolute;right:0px;top:0px;" @click="confirmAngle" type="success" circle icon="el-icon-check"></el-button>
  </div>
  </div>
  
</template>
<script>
   import {ModelModificationCommand} from './commands/ModelModificationCommand.js'
export default {
  data: function() {
    return {
      sliderVal: 0 ,
      min:0,
      max:10,
      sliderstep:0.1
    }
  },
  mounted: function(){
    $('#modelSlider').hide();
  },
  methods: {
    moveModel : function(){
        var eventArg = {'command': new ModelModificationCommand(0, this)};
        this.$emit("modelModificationCommand", eventArg);
    },
    scaleModel : function(){
        this.sliderVal=1;
        var eventArg = {'command': new ModelModificationCommand(1, this)};
        this.$emit("modelModificationCommand", eventArg);
    },
    rotateModel : function(){
        this.sliderVal=0;
        var eventArg = {'command': new ModelModificationCommand(2, this)};
        this.$emit("modelModificationCommand", eventArg);
    },
    deleteModel : function(){
        var eventArg = {'command': new ModelModificationCommand(3, this)};
        this.$emit("modelModificationCommand", eventArg);
    },
    confirmAngle : function(){
      var eventArg = {'command': new ModelModificationCommand(4, this)};
        this.$emit("modelModificationCommand", eventArg);
    },
    sliderChange : function(){
     var eventArg = {'command': new ModelModificationCommand(5, this)};
        this.$emit("modelModificationCommand", eventArg); 
    },
    showModelRoute : function(){
      var eventArg = {'command': new ModelModificationCommand(6, this)};
        this.$emit("modelModificationCommand", eventArg);
    },
    close:function(){
        $('#modelModifiPanel').hide();
    }

  }
}
</script>
<style>
  #modelSlider{
    position:absolute;
    width:210px;
    left:0px;
    top:0px;
  }
</style>



// WEBPACK FOOTER //
// src/plugins/components/Web3dModels/ModelModificationPanel.vue